import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SubrentalOutputDetailTableModel } from 'src/app/models/tables/subrental/subrental-output-detail-table.model';
import { SubrentalOutputTableModel } from 'src/app/models/tables/subrental/subrental-output-table.model';
import { HeaderService } from 'src/app/services/header/header.service';
import { SubrentalOutputDetailService } from 'src/app/services/subrental/subrental-output-detail.service';
import { SubrentalOutputService } from 'src/app/services/subrental/subrental-output.service';

@Component({
  selector: 'app-subrental-output',
  templateUrl: './subrental-output.component.html',
  styleUrls: ['./subrental-output.component.scss'],
  standalone: false
})
export class SubrentalOutputComponent implements OnInit {
  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  detailData: PagedResponseModel<SubrentalOutputDetailTableModel> = new PagedResponseModel<SubrentalOutputDetailTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  filters: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<SubrentalOutputTableModel> = new PagedResponseModel<SubrentalOutputTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  limit: number = 10;
  listObservers: Subscription[] = [];
  nameWindow: string = 'Salidas de Subalquiler';
  page: number = 1;
  previousSort: { field: string; isAscsendant: number };
  projectName = ProjectName.projectName;
  subrentalOutputId: number = 0;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];

  constructor(private router: Router,
    private title: Title,
    private headerService: HeaderService,
    private subrentalOutputService: SubrentalOutputService,
    private subrentalOutputDetailService: SubrentalOutputDetailService) { }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem('subrentalOutput');
    filters ? this.filters = JSON.parse(filters) : [];
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getAllSubrentalOutputsWithPagination()
    ]);
  }

  async exportDetailConsultation() {
    try {
      const blob = await firstValueFrom(this.subrentalOutputDetailService.exportDetailConsultation(this.filters, this.columnSort, this.ascendant));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Salidas Subalquiler Detalle.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar las salidas de subalquiler detalle.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const blob = await firstValueFrom(this.subrentalOutputService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Salidas Subalquiler.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar las salidas de subalquiler.', error);
    }
  }


  async getAllSubrentalOutputsWithPagination() {
    try {
      this.generalData = await firstValueFrom(this.subrentalOutputService.getSubrentalOutputsForGeneralConsultation(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar las salidas de subalquiler.', error);
    }
  }


  async getColumnsForDetailConsultation() {
    try {
      if (this.detailHeader.length === 0) {
        this.detailHeader = await firstValueFrom(this.subrentalOutputDetailService.getColumnsForDetailConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta detalle.', error);
    }
  }


  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.subrentalOutputService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getSubrentalOutputDetailsForDetailConsultation() {
    try {
      this.detailData = await firstValueFrom(this.subrentalOutputDetailService.getSubrentalOutputDetailsForDetailConsultation(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar los detalles de las salidas de subalquiler.', error);
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.length = this.detailHeader.length === 1 ? 0 : this.detailHeader.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getAllSubrentalOutputsWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailConsultation(),
          this.getSubrentalOutputDetailsForDetailConsultation()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  newSubrentalOutput() {
    this.router.navigate(['/subrental-output/register']);
  }

  onAction(event: { action: string, item?: SubrentalOutputTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/subrental-output/register/${event.item.id}`]);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getAllSubrentalOutputsWithPagination();
        break;
      case 1:
        await this.getSubrentalOutputDetailsForDetailConsultation();
        break;
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailConsultation();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);
    // Procesar cada filtro
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  private removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  private processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }
}
